import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

const getVietQRShortName = (bankName) => {
    if (!bankName) return "";
    const nameStr = bankName.toUpperCase().trim();
    
    // Các ngân hàng bạn đã làm sẵn
    if (nameStr.includes("VIETCOMBANK")) return "VCB";
    if (nameStr.includes("TECHCOMBANK")) return "TCB";
    if (nameStr.includes("VIETINBANK")) return "ICB";
    if (nameStr.includes("VPBANK")) return "VPB";
    if (nameStr.includes("KIENLONGBANK")) return "KLB";
    if (nameStr.includes("TPBANK")) return "TPB";
    if (nameStr.includes("MBBANK") || nameStr === "MB BANK" || nameStr === "MB") return "MB";
    if (nameStr.includes("AGRIBANK")) return "VBA";
    if (nameStr.includes("SACOMBANK")) return "STB";
    if (nameStr.includes("SEABANK")) return "SEAB";
    
    // Bổ sung đầy đủ từ API
    if (nameStr.includes("BIDV")) return "BIDV";
    if (nameStr.includes("OCB")) return "OCB";
    if (nameStr.includes("ACB")) return "ACB";
    if (nameStr.includes("HDBANK")) return "HDB";
    if (nameStr.includes("VIETCAPITALBANK")) return "VCCB";
    if (nameStr.includes("SCB")) return "SCB";
    if (nameStr.includes("VIB")) return "VIB";
    if (nameStr.includes("SHINHANBANK")) return "SHBVN"; 
    if (nameStr.includes("SHB") && !nameStr.includes("SHINHAN")) return "SHB"; 
    if (nameStr.includes("EXIMBANK")) return "EIB";
    if (nameStr.includes("MSB")) return "MSB";
    if (nameStr.includes("CAKE")) return "CAKE";
    if (nameStr.includes("UBANK")) return "UBANK"; 
    if (nameStr.includes("VIETTELMONEY")) return "VIETTELMONEY";
    if (nameStr.includes("TIMO")) return "TIMO";
    if (nameStr.includes("VNPTMONEY")) return "VNPTMONEY";
    if (nameStr.includes("SAIGONBANK")) return "SGICB";
    if (nameStr.includes("BACABANK")) return "BAB";
    if (nameStr.includes("MOMO")) return "momo";
    if (nameStr.includes("PVCOMBANK PAY")) return "PVCB";
    if (nameStr.includes("PVCOMBANK")) return "PVCB";
    if (nameStr.includes("MBV")) return "MBV";
    if (nameStr.includes("NCB")) return "NCB";
    if (nameStr.includes("ABBANK")) return "ABB";
    if (nameStr.includes("VIETABANK")) return "VAB";
    if (nameStr.includes("NAMABANK")) return "NAB";
    if (nameStr.includes("PGBANK")) return "PGB";
    if (nameStr.includes("VIETBANK")) return "VIETBANK";
    if (nameStr.includes("BAOVIETBANK")) return "BVB";
    if (nameStr.includes("COOPBANK")) return "COOPBANK";
    if (nameStr.includes("LPBANK")) return "LPB";
    if (nameStr.includes("KBANK")) return "KBANK";
    if (nameStr.includes("MAFC")) return "MAFC";
    if (nameStr.includes("HONGLEONG")) return "HLBVN";
    if (nameStr.includes("KEBHANAHN")) return "KEBHANAHN";
    if (nameStr.includes("KEBHANAHCM")) return "KEBHANAHCM";
    if (nameStr.includes("CITIBANK")) return "CITIBANK";
    if (nameStr.includes("CBBANK")) return "CBB";
    if (nameStr.includes("CIMB")) return "CIMB";
    if (nameStr.includes("DBSBANK")) return "DBS";
    if (nameStr.includes("VIKKI")) return "Vikki";
    if (nameStr.includes("VBSP")) return "VBSP";
    if (nameStr.includes("GPBANK")) return "GPB";
    if (nameStr.includes("KOOKMINHCM")) return "KBHCM";
    if (nameStr.includes("KOOKMINHN")) return "KBHN";
    if (nameStr.includes("WOORI")) return "WVN";
    if (nameStr.includes("VRB")) return "VRB";
    if (nameStr.includes("HSBC")) return "HSBC";
    if (nameStr.includes("IBKHN")) return "IBK";
    if (nameStr.includes("IBKHCM")) return "IBK";
    if (nameStr.includes("INDOVINABANK")) return "IVB";
    if (nameStr.includes("UNITEDOVERSEAS")) return "UOB";
    if (nameStr.includes("NONGHYUP")) return "NHB";
    if (nameStr.includes("STANDARDCHARTERED")) return "SCVN";
    if (nameStr.includes("PUBLICBANK")) return "PBVN";

    return nameStr;
};

const LEFT_TABS = [
    { id: 'bank', title: 'Ngân Hàng Trực Tuyến', tag: 'Tặng Thêm 0.8%', icon: 'https://cdn-icons-png.flaticon.com/512/2830/2830284.png' },
    { id: 'momo', title: 'Momo', tag: 'Nạp Nhanh', icon: 'https://cdn.haitrieu.com/wp-content/uploads/2022/10/Logo-MoMo-Square.png' },
    { id: 'zalopay', title: 'ZaloPay', tag: 'Nạp Nhanh', icon: 'https://cdn.haitrieu.com/wp-content/uploads/2022/10/Logo-ZaloPay-Square.png' },
    { id: 'viettelmoney', title: 'ViettelPay', tag: 'Nạp Nhanh', icon: 'https://brandlogos.net/wp-content/uploads/2021/10/ViettelPay-logo-1.png' }
];

function Recharge({ profile, getProfile }) {
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [payment, setPayment] = useState([]);
    const [newMoney, setNewMoney] = useState("");
    const [loading, setLoading] = useState(false);
    
    const [activeTab, setActiveTab] = useState('bank');
    
    const [listBank, setListBank] = useState([]);
    const [selectedBank, setSelectedBank] = useState(null); 
    const [selectedAmount, setSelectedAmount] = useState(null);

    // =====================================
    // STATE QUẢN LÝ SỰ KIỆN (EVENTS)
    // =====================================
    const [events, setEvents] = useState([]);
    // MẶC ĐỊNH LÀ "NONE" ĐỂ KHÔNG CHỌN KHUYẾN MÃI KHI VÀO TRANG
    const [promoOption, setPromoOption] = useState('NONE'); 

    const { handleSubmit } = useForm();

    const amountOptions = [
        { label: "50.000", value: 50000 },
        { label: "100.000", value: 100000 },
        { label: "200.000", value: 200000 },
        { label: "500.000", value: 500000 },
        { label: "1.000.000", value: 1000000 },
        { label: "3.000.000", value: 3000000 },
        { label: "5.000.000", value: 5000000 },
        { label: "10.000.000", value: 10000000 },
        { label: "50.000.000", value: 50000000 },
        { label: "100.000.000", value: 100000000 },
        { label: "200.000.000", value: 200000000 }
    ];

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        // 1. Lấy danh sách ngân hàng
        axios.get(`${process.env.REACT_APP_API_URL}/bank/getBanks`, {})
            .then((res) => {
                if (res.data && res.data.success) {
                    setListBank(res.data.data);
                    if(res.data.data.length > 0) setSelectedBank(res.data.data[0].bankCode);
                }
            }).catch(() => setListBank([]));

        // 2. Lấy cài đặt hệ thống
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {})
            .then((res) => {
                if (res.data.data) {
                    setSetting(res.data.data[0]);
                    localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
                }
            }).catch(() => setSetting(null));

        // 3. Lấy lịch sử nạp tiền (Dùng để tính xem User đã tham gia sự kiện mấy lần)
        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`, {})
            .then((res) => {
                if (res.data && res.data.data && Array.isArray(res.data.data)) {
                    setPayment(res.data.data);
                }
            }).catch(() => setPayment([]));

        // 4. LẤY DANH SÁCH SỰ KIỆN TỪ BACKEND
        axios.get(`${process.env.REACT_APP_API_URL}/event/getevent`, {})
            .then((res) => {
                if (res.data && res.data.success && Array.isArray(res.data.data)) {
                    // Chỉ lấy các sự kiện đang bật (Active)
                    const activeEvents = res.data.data.filter(e => e.status === "Active");
                    setEvents(activeEvents);
                }
            }).catch((err) => console.error("Lỗi lấy sự kiện:", err));

    }, []);

    const handleSelectAmount = (val) => {
        setSelectedAmount(val);
        setNewMoney(val.toLocaleString("vi-VN"));
    };

    const handleInputChange = (e) => {
        setSelectedAmount(null); 
        const val = e.target.value.replaceAll(".", "").replaceAll(",", "");
        if (!isNaN(val) && val !== "") {
            setNewMoney(Number(val).toLocaleString("vi-VN"));
        } else {
            setNewMoney("");
        }
    };

    const onSubmit = () => {
        const rawAmount = Number(newMoney.replaceAll(".", "").replaceAll(",", ""));

        if (activeTab === 'bank' && !selectedBank) return swal("Thông báo", "Vui lòng chọn ngân hàng bạn muốn nạp", "error");
        
        if (rawAmount <= 0 || isNaN(rawAmount)) return swal("Thông báo", "Vui lòng nhập số tiền hợp lệ", "error");
        if (setting && rawAmount < setting.minnap) return swal("Chú ý", `Số tiền nạp tối thiểu là ${(setting.minnap).toLocaleString("vi-VN")}`, "warning");
        if (setting && rawAmount > setting.maxnap) return swal("Chú ý", `Số tiền nạp tối đa là ${(setting.maxnap).toLocaleString("vi-VN")}`, "warning");

        // Nếu user có chọn sự kiện, kiểm tra min_deposit của sự kiện đó
        if (promoOption !== 'NONE') {
            const selectedEvent = events.find(e => e._id === promoOption);
            if (selectedEvent && rawAmount < selectedEvent.min_deposit) {
                return swal("Chú ý", `Sự kiện "${selectedEvent.title}" yêu cầu nạp tối thiểu ${(selectedEvent.min_deposit).toLocaleString("vi-VN")} VNĐ`, "warning");
            }
        }

        if (payment && payment.length > 0) {
            const pendingCount = payment.filter((obj) => obj.status_payment === "Pending" && obj.type_payment === "NẠP").length;
            if (pendingCount >= 15) return swal("Thông báo", "Bạn đang có lệnh nạp chưa xử lý. Vui lòng thanh toán hoặc chờ hệ thống.", "error");
        }

        setLoading(true);

        let gateCode = "003";
        let finalBankCode = null;

        if (activeTab === 'momo') gateCode = "004";
        else if (activeTab === 'zalopay') gateCode = "005";
        else if (activeTab === 'viettelmoney') gateCode = "006";
        else {
            gateCode = "003";
            finalBankCode = selectedBank;
        }

        // Tạo cấu trúc dữ liệu đẩy xuống Backend
        const payload = {
            amount: rawAmount,
            gate: gateCode,
            type: activeTab,
            bankCode: finalBankCode,
            promotion: promoOption !== 'NONE' ? 'EVENT' : 'NONE', 
            eventId: promoOption !== 'NONE' ? promoOption : null 
        };

        axios.post(`${process.env.REACT_APP_API_URL}/bank/createTrans`, payload)
            .then((res) => {
                setLoading(false);
                window.open(res.data.data.url, "_blank");
                swal("Đã mở trang nạp tiền", "Vui lòng hoàn tất thanh toán ở tab mới.", "success");
            })
            .catch((err) => {
                setLoading(false);
                swal("Thất bại", err.response?.data?.message || "Hệ thống nạp tiền đang bảo trì, vui lòng thử lại.", "error");
            });
    };

    return (
        <>
            <style dangerouslySetInnerHTML={{__html: `
                .rc-wrapper {
                    display: flex;
                    width: 100%;
                    font-family: Arial, sans-serif;
                    background: #fff;
                    min-height: 550px;
                }
                .rc-left {
                    width: 260px;
                    border-right: 1px solid #f0f0f0;
                    padding: 15px;
                    background: #fff;
                    flex-shrink: 0;
                }
                .rc-menu-item {
                    border: 1px solid #e0e0e0;
                    border-radius: 6px;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    cursor: pointer;
                    margin-bottom: 10px;
                    background: #fff;
                    transition: 0.2s;
                }
                .rc-menu-item:hover { border-color: #ff4d4f; }
                .rc-menu-item.active {
                    border-color: #ff4d4f;
                    box-shadow: 0 2px 4px rgba(255, 77, 79, 0.1);
                }
                .rc-menu-item.active::after {
                    content: '✓';
                    position: absolute;
                    bottom: -1px;
                    right: -1px;
                    background: #ff4d4f;
                    color: #fff;
                    width: 18px;
                    height: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 11px;
                    border-radius: 4px 0 4px 0;
                }
                .rc-menu-item img {
                    width: 38px;
                    height: 38px;
                    object-fit: contain;
                    margin-right: 12px;
                }
                .rc-menu-text { display: flex; flex-direction: column; }
                .rc-menu-title { font-size: 14px; color: #333; margin-bottom: 2px; }
                .rc-menu-tag { font-size: 12px; color: #ff4d4f; }

                .rc-right {
                    flex: 1;
                    padding: 15px 30px;
                }
                .rc-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #f0f0f0;
                    padding-bottom: 10px;
                    margin-bottom: 20px;
                }
                .rc-title { font-size: 15px; color: #333; font-weight: bold; border-left: 3px solid #52c41a; padding-left: 8px; }
                
                .rc-row {
                    display: flex;
                    margin-bottom: 25px;
                }
                .rc-label {
                    width: 120px;
                    font-size: 14px;
                    color: #555;
                    padding-top: 6px;
                }
                .rc-controls { flex: 1; }

                .rc-bank-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 15px 20px;
                }
                .rc-bank-logo-wrapper {
                    padding: 5px;
                    border: 1px solid #00000033; 
                    border-radius: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    height: 45px;
                    transition: 0.2s;
                }
                .rc-bank-logo-wrapper:hover { background: #f9f9f9; }
                .rc-bank-logo-wrapper.active {
                    border: 1px solid #ff4d4f;
                }
                .rc-bank-img {
                    max-height: 28px;
                    max-width: 110px;
                    object-fit: contain;
                }

                .rc-amount-grid {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px 10px;
                    margin-bottom: 15px;
                }
                .rc-amount-btn {
                    border: 1px solid #e0e0e0;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    color: #666;
                    cursor: pointer;
                    background: #fff;
                    transition: 0.2s;
                }
                .rc-amount-btn:hover { border-color: #ff4d4f; color: #ff4d4f; }
                .rc-amount-btn.active {
                    border-color: #ff4d4f;
                    color: #ff4d4f;
                }

                .rc-input {
                    width: 250px;
                    height: 38px;
                    border: 1px solid #e0e0e0;
                    border-radius: 4px;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #f9f9f9;
                    outline: none;
                }
                .rc-input:focus { border-color: #ff4d4f; background: #fff; }
                .rc-limit {
                    display: block;
                    font-size: 12px;
                    color: #ff4d4f;
                    margin-top: 8px;
                }

                /* --- CSS KHUYẾN MÃI MỚI (CHUẨN UI/UX) --- */
                .promo-container {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    width: 100%;
                }
                .promo-card, .promo-none-card {
                    border: 1px solid #e2e8f0; 
                    border-radius: 8px; 
                    padding: 12px 16px;
                    background: #ffffff;
                    cursor: pointer;
                    display: flex;
                    align-items: flex-start; 
                    transition: all 0.2s ease;
                }
                .promo-card:hover, .promo-none-card:hover {
                    border-color: #ff4d4f;
                }
                .promo-card.active, .promo-none-card.active {
                    border-color: #ff4d4f;
                    background-color: #fff1f0; 
                }

                .promo-radio-input {
                    margin-top: 3px; 
                    margin-right: 12px;
                    accent-color: #ff4d4f;
                    width: 18px;
                    height: 18px;
                    cursor: pointer;
                    flex-shrink: 0;
                }

                .promo-body { 
                    flex: 1; 
                    display: flex;
                    flex-direction: column;
                }
                .promo-title-line {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    gap: 8px;
                }
                .promo-title {
                    font-size: 14px;
                    color: #1e293b;
                    font-weight: 600;
                    line-height: 1.4;
                }
                .promo-badge {
                    font-size: 12px;
                    font-weight: 600;
                    color: #ff4d4f;
                    background: #ffe4e4;
                    padding: 2px 8px;
                    border-radius: 20px; 
                    white-space: nowrap;
                }
                .promo-desc {
                    font-size: 13px;
                    color: #64748b;
                    margin-top: 4px;
                }
                .promo-footnote {
                    font-size: 12px;
                    color: #ff4d4f;
                    font-style: italic;
                    margin-top: 6px;
                }

                .promo-none-card {
                    align-items: center; 
                    padding: 14px 16px;
                }
                .promo-none-card .promo-radio-input {
                    margin-top: 0; 
                }
                .promo-none-title {
                    font-size: 14px;
                    color: #334155;
                    font-weight: 500;
                }

                .rc-submit-area {
                    text-align: center;
                    margin-top: 30px;
                }
                .rc-submit-btn {
                    background: #ff4d4f;
                    color: #fff;
                    border: none;
                    padding: 10px 35px;
                    border-radius: 20px;
                    font-size: 14px;
                    font-weight: bold;
                    cursor: pointer;
                    box-shadow: 0 4px 6px rgba(255, 77, 79, 0.2);
                    transition: 0.2s;
                }
                .rc-submit-btn:hover { background: #d9363e; }
            `}} />

            {loading && (
                <div className="loading" style={{zIndex: 9999}}>
                    <div className="loader"></div>
                </div>
            )}
            
            <div className="recharge" style={{ padding: '0', background: 'transparent' }}>
                {profile && (
                    <div className="rc-wrapper">
                        
                        {/* CỘT TRÁI */}
                        <div className="rc-left">
                            {LEFT_TABS.map((tab) => (
                                <div 
                                    key={tab.id}
                                    className={`rc-menu-item ${activeTab === tab.id ? 'active' : ''}`}
                                    onClick={() => {
                                        setActiveTab(tab.id);
                                        setSelectedBank(null); 
                                    }}
                                >
                                    <img src={tab.icon} alt={tab.title} />
                                    <div className="rc-menu-text">
                                        <span className="rc-menu-title">{tab.title}</span>
                                        <span className="rc-menu-tag">{tab.tag}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CỘT PHẢI */}
                        <div className="rc-right">
                            <div className="rc-header">
                                <div className="rc-title">Thông tin tiền gửi</div>
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                
                                {activeTab === 'bank' && (
                                    <div className="rc-row">
                                        <div className="rc-label">Ngân hàng:</div>
                                        <div className="rc-controls">
                                            <div className="rc-bank-grid">
                                                {listBank.map((bank, index) => {
                                                    const shortName = getVietQRShortName(bank.bankName);
                                                    return (
                                                        <div 
                                                            key={index}
                                                            className={`rc-bank-logo-wrapper ${selectedBank === bank.bankCode ? 'active' : ''}`}
                                                            onClick={() => setSelectedBank(bank.bankCode)}
                                                        >
                                                            <img 
                                                                className="rc-bank-img"
                                                                src={`https://api.vietqr.io/img/${shortName}.png`} 
                                                                alt={bank.bankName} 
                                                                onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png" }} 
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="rc-row">
                                    <div className="rc-label">Số tiền nạp:</div>
                                    <div className="rc-controls">
                                        <div className="rc-amount-grid">
                                            {amountOptions.map((opt, idx) => (
                                                <div 
                                                    key={idx}
                                                    className={`rc-amount-btn ${selectedAmount === opt.value ? 'active' : ''}`}
                                                    onClick={() => handleSelectAmount(opt.value)}
                                                >
                                                    {opt.label}
                                                </div>
                                            ))}
                                        </div>
                                        <div>
                                            <input
                                                className="rc-input"
                                                type="text"
                                                placeholder="Số tiền nạp"
                                                value={newMoney}
                                                onChange={handleInputChange}
                                            />
                                            {setting && (
                                                <span className="rc-limit">
                                                    Giới hạn tiền gửi: {(setting.minnap).toLocaleString('vi-VN')}đ - {(setting.maxnap).toLocaleString('vi-VN')}đ
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* KHU VỰC CHỌN SỰ KIỆN (LUÔN LUÔN HIỂN THỊ KỂ CẢ KHI events LÀ RỖNG) */}
                                <div className="rc-row">
                                    <div className="rc-label" style={{ paddingTop: '10px' }}>Chọn khuyến mãi:</div>
                                    <div className="rc-controls">
                                        <div className="promo-container">
                                            
                                            {/* MAP QUA TỪNG SỰ KIỆN NẾU CÓ */}
                                            {events && events.map((evt) => {
                                                const usedCount = payment.filter(p => 
                                                    p.type_payment === "NẠP" && 
                                                    p.status_payment === "Success" && 
                                                    p.eventId === evt._id
                                                ).length;
                                                
                                                const maxTurns = evt.turns || 1;
                                                const isMaxedOut = usedCount >= maxTurns;

                                                // Ẩn sự kiện nếu đã dùng hết lượt
                                                if (isMaxedOut) return null;

                                                return (
                                                    <div 
                                                        key={evt._id}
                                                        className={`promo-card ${promoOption === evt._id ? 'active' : ''}`}
                                                        onClick={() => setPromoOption(evt._id)}
                                                    >
                                                        <input 
                                                            type="radio" 
                                                            className="promo-radio-input" 
                                                            checked={promoOption === evt._id} 
                                                            onChange={() => setPromoOption(evt._id)}
                                                        />
                                                        <div className="promo-body">
                                                            <div className="promo-title-line">
                                                                <span className="promo-title">{evt.title} ({usedCount}/{maxTurns})</span>
                                                                <span className="promo-badge">≥{(evt.min_deposit || 0).toLocaleString('vi-VN')}đ</span>
                                                            </div>
                                                            <div className="promo-desc">{evt.content}</div>
                                                            <div className="promo-footnote">
                                                                *Nhận ngay {evt.bonus_type === 'PERCENT' ? `${evt.bonus_value}%` : `${(evt.bonus_value).toLocaleString('vi-VN')}đ`}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}

                                            {/* NÚT TỪ CHỐI KHUYẾN MÃI (LUÔN HIỂN THỊ) */}
                                            <div 
                                                className={`promo-none-card ${promoOption === 'NONE' ? 'active' : ''}`}
                                                onClick={() => setPromoOption('NONE')}
                                            >
                                                <input 
                                                    type="radio" 
                                                    className="promo-radio-input" 
                                                    checked={promoOption === 'NONE'} 
                                                    onChange={() => setPromoOption('NONE')}
                                                />
                                                <span className="promo-none-title">Không tham gia bất kỳ chương trình khuyến mãi nào</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="rc-submit-area">
                                    <button type="submit" className="rc-submit-btn">
                                        Xác nhận nạp tiền
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default Recharge;